import Editor, { loader } from '@monaco-editor/react';
import { useSchemaViewerContext } from './SchemaContext';

// monacoVsPath: absolute URL to the vs/ directory (used to load workerMain.js)
const monacoVsPath = `${window.location.origin}${process.env.PUBLIC_URL}/monaco-editor/min/vs`;
// monacoBaseUrl: parent of vs/ — AMD module IDs already start with "vs/...", so
// baseUrl must be the directory *containing* vs/ to avoid resolving "vs/vs/..." double-prefix.
const monacoBaseUrl = `${window.location.origin}${process.env.PUBLIC_URL}/monaco-editor/min/`;

loader.config({ paths: { vs: `${process.env.PUBLIC_URL}/monaco-editor/min/vs` } });

(window as Window & { MonacoEnvironment?: { getWorkerUrl: (moduleId: string, label: string) => string } }).MonacoEnvironment = {
  getWorkerUrl: (_moduleId: string, _label: string): string => {
    // workerMain.js bootstraps Monaco's AMD loader using baseUrl, then receives the
    // language module to load via Monaco's internal postMessage protocol.
    // Using a blob: URL (allowed by CSP worker-src) with an absolute baseUrl ensures
    // importScripts inside the worker always resolves correctly regardless of origin.
    const blob = new Blob(
      [`self.MonacoEnvironment = { baseUrl: '${monacoBaseUrl}' }; importScripts('${monacoVsPath}/base/worker/workerMain.js');`],
      { type: 'text/javascript' }
    );
    return URL.createObjectURL(blob);
  }
};

export const SchemaEditor = () => {
  const { schema, formData, setFormData } = useSchemaViewerContext()

  const editorOptions = {
    minimap: { enabled: false },
    automaticLayout: true,
    fontSize: 12,
    lineNumbers: 'on' as const,
    scrollBeyondLastLine: false,
    wordWrap: 'on' as const
  };

  const handleEditorChange = (value: string | undefined) => {
    if (value) {
      try {
        const parsedData = JSON.parse(value);
        setFormData(parsedData);
      } catch (error) {
        // noop
      }
    }
  };

  return (
    <div style={{ padding: '2rem', display: 'flex', flexDirection: 'row', height: '100%', gap: '1rem' }}>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', borderRadius: '4px', border: '1px solid #ccc', minWidth: 0 }}>
        <div style={{ padding: '8px 12px', backgroundColor: '#e9e9e9', color: '#333', fontWeight: 'bold', flexShrink: 0 }}>
          JSON Schema
        </div>
        <div style={{ flexGrow: 1, overflow: 'hidden' }}>
          <Editor
            height="100%"
            defaultLanguage="json"
            options={{ ...editorOptions, readOnly: true }}
            defaultValue="{}"
            value={schema ? JSON.stringify(schema, null, 2) : '{}'}
          />
        </div>
      </div>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', borderRadius: '4px', border: '1px solid #ccc', minWidth: 0 }}>
        <div style={{ padding: '8px 12px', backgroundColor: '#e9e9e9', color: '#333', fontWeight: 'bold', flexShrink: 0 }}>
          Form Data
        </div>
        <div style={{ flexGrow: 1, overflow: 'hidden' }}>
          <Editor
            height="100%"
            defaultLanguage="json"
            options={editorOptions}
            onChange={handleEditorChange}
            defaultValue="{}"
            value={formData ? JSON.stringify(formData, null, 2) : '{}'}
          />
        </div>
      </div>
    </div>
  );
};
